import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, ContentChild, ViewContainerRef, Input } from '@angular/core';
import { faCog, faAngleRight, faPlus, faInfoCircle, faCalculator, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { isNullOrEmpty, isNullOrUndefined, isNullOrUndefinedObject } from 'src/app/helper/validation';
import { SharedService } from '../../helper/shared/shared.service';
import { ProjectService } from '../../project/project.service';
import { UserInfoService } from '../../user-info/user-info.service';
import { ProgramSettingsService } from '../../program-settings/program-settings.service';
import { CalculateService } from '../../helper/calculate/calculate.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { createPopper } from '@popperjs/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-astm',
  templateUrl: './astm.component.html',
  styleUrls: ['./astm.component.scss']
})
export class AstmComponent implements OnInit {
  @Output() nextStep = new EventEmitter<String>();

  @ViewChild('txtSolName0', {static: false} ) txtSolName0:ElementRef<HTMLInputElement>;
  @ViewChild('txtSolName1', {static: false} ) txtSolName1:ElementRef<HTMLInputElement>;
  @ViewChild('txtSolName2', {static: false} ) txtSolName2:ElementRef<HTMLInputElement>;

  @ViewChild('txtAirflow', {static: true} ) txtAirflow:any;
  @ViewChild('datalistAirflow', {static: true} ) datalistAirflow:any;

  @ViewChild('txtTemperature', {static: true} ) txtTemperature:any;
  @ViewChild('datalistTemperature', {static: true} ) datalistTemperature:any;

  @ViewChild('txtRH', {static: true} ) txtRH:any;
  @ViewChild('datalistRH', {static: true} ) datalistRH:any;

  @ViewChild('txtContamination0', {static: false} ) txtContamination0;
  @ViewChild('txtContamination1', {static: false} ) txtContamination1;
  @ViewChild('txtContamination2', {static: false} ) txtContamination2;

  @ViewChild('datalistContamination0', {static: false} ) datalistContamination0;
  @ViewChild('datalistContamination1', {static: false} ) datalistContamination1;
  @ViewChild('datalistContamination2', {static: false} ) datalistContamination2;

  @ViewChild('txtMedia0', {static: false} ) txtMedia0;
  @ViewChild('txtMedia1', {static: false} ) txtMedia1;
  @ViewChild('txtMedia2', {static: false} ) txtMedia2;

  @ViewChild('datalistMedia0', {static: false} ) datalistMedia0;
  @ViewChild('datalistMedia1', {static: false} ) datalistMedia1;
  @ViewChild('datalistMedia2', {static: false} ) datalistMedia2;

  faCog = faCog;
  faPlus = faPlus;
  faInfoCircle = faInfoCircle;
  faAngleRight = faAngleRight;
  faCalculator = faCalculator;
  faCheckCircle = faCheckCircle;
  loading: boolean;
  inum: number = 0;
  itotalsol: number = 0;
  arrSolEditMode = [false, false, false];
  arrsolname = ['Solution 1', 'Solution 2', 'Solution 3'];
  hoursperdayval = 24;
  daysperweekval= 7;
  weeksperyearval = 52;
  formatcalculatedTotalHours: any;
  datalistShow="";

  UnitsFromUserData: any;
  AllDDLList: any;
  airflowList: any;
  temperatureList: any;
  RHList: any;
  contaminationList: any[];
  contaminationList1: any[];
  contaminationList2: any[];
  contaminationList3: any[];
  mediaList: any
  mediaList1: any[];
  mediaList2: any[];
  mediaList3: any[];
  hoursperDayList: any;
  daysperWeekList: any;
  weeksperYearList: any;
  airVolumeUnitm3h = 'm³';
  airVolumeUnitft3 = 'ft³';
  totAirVolume: any;
  airVolumeUnit: any;

  NumberFormat = '';
  closeResult: string;
  solname1: string;
  solname2: string;
  solname3: string;
  solName1: string;
  solName2: string;
  solName3: string;
  contaminationType1: string;
  contaminationType2: string;
  contaminationType3: string;
  mediaType1: string;
  mediaType2: string;
  mediaType3: string;
  media1: string;
  media2: string;
  media3: string;
  concentrationValue1: string;
  concentrationValue2: string;
  concentrationValue3: string;

  AddSolutionInfo:any;
  contamination: any;
  //contamination = this.projectService.getContaminationEmptyValueStructure();
  solutions = [];
  intervalID;

  // For Program Settings PopUp - START
  unitlist: any = this.programSettingsService.unitList;
  concUnitlist: any;
  airFlowUnitlist: any;
  formatlist: any = this.programSettingsService.formatList;
  userUnit = "";
  //userUnit = this.projectService.projectdetails.projectInfo.unitId;
  selectedConcUnit = "";

  selConcUnitFromProgSettings = "";
  selUnitFromProgSettings = 0;
  selAirFlowUnitFromProgSettings = "";

  disableFlag = false;
  // For Program Settings PopUp - END

  constructor(
    private toastr: ToastrService,
    public sharedService: SharedService,
    public projectService: ProjectService,
    private userInfoService: UserInfoService,
    private calculateService: CalculateService,
    private modalService: NgbModal,
    public programSettingsService: ProgramSettingsService,
    public route: ActivatedRoute,    
  ) { }

  ngOnInit(): void {
    this.projectService.activePage = 3;

    if (this.route.snapshot.url[0].path.toLowerCase() == 'projectedit') {
      this.projectService.listData = this.sharedService.listData;

      //Get Media Name must put here because during loading records the media is still not loaded
      //this.getMediaName();

      if (this.sharedService.blnLoadFromRecord == true) {
        let data=this.projectService.getProjectStructure(this.sharedService.loadFromDatabase); 
        
      } else {

      }

      if (this.projectService.projectdetails.results != undefined) {
        if (this.projectService.projectdetails.results.solutionsResults != undefined) {
          if (this.projectService.projectdetails.results.solutionsResults.length == 0) {
              this.sharedService.blnLoadFromRecord = true; 
          }
        }
      }
      
      if (this.sharedService.projectNotCalc) {
        this.sharedService.blnLoadFromRecord = true; 
      }
    } else if (this.route.snapshot.url[0].path.toLowerCase() == 'importxml' && this.sharedService.projectNotCalc == true) {
      if (this.sharedService.LoadingXML == true) {
        this.projectService.listData = this.sharedService.listData;
        let data=this.projectService.getProjectStructure(this.sharedService.importXMLData);

        this.sharedService.LoadingXML = false;
      }
    }

    this.userUnit = this.projectService.projectdetails.projectInfo.unitId;
    this.contamination = this.projectService.projectdetails.contamination;
    this.contamination.applicationType = 'ASTM';
    this.solutions = this.projectService.projectdetails.solutions;

    let gasDetailLen = this.projectService.projectdetails.contamination.gasDetails.length;
    if (gasDetailLen > 0) {
      for (let i=0; i < gasDetailLen; i++) {
        let gasDet = this.projectService.projectdetails.contamination.gasDetails[i];
        switch (i) {
          case 0:
             this.contaminationType1 = gasDet.contaminationType;
             this.concentrationValue1 = gasDet.concentrationValue;
            break;
          case 1:
            this.contaminationType2 = gasDet.contaminationType;
            this.concentrationValue2 = gasDet.concentrationValue;
            break;
          case 2:
          this.contaminationType3 = gasDet.contaminationType;
          this.concentrationValue3 = gasDet.concentrationValue;
          break;
        }
      }
    }

    let solutionslLen = this.projectService.projectdetails.solutions.length;
    if (solutionslLen ===0) {
      this.addSolution();
    }else if (solutionslLen > 0) {
      for (let i=0; i < solutionslLen; i++) {
        let sol = this.projectService.projectdetails.solutions[i];
        if (sol.solutionDetails.length === 0) {
          this.addSolutionDetail(this.projectService.projectdetails.solutions[i]);
        }
        switch (i) {
          case 0 :
            this.mediaType1 = sol.solutionDetails[0].filterName;
            break;
          case 1 :
              this.mediaType2 = sol.solutionDetails[0].filterName;
              //(<HTMLInputElement>document.getElementById('txtMedia1')).value = sol.solutionDetails[0].filterName;
              break;
          case 2 :
            this.mediaType3 = sol.solutionDetails[0].filterName;
            //(<HTMLInputElement>document.getElementById('txtMedia2')).value = sol.solutionDetails[0].filterName;
            break;
        }
      }
    }

    if (this.projectService.projectdetails.solutions[0].solutionDetails.length===0) {
      let newSolDetails = this.projectService.getsolutionDetailsEmptyvalueStructure();
      this.projectService.projectdetails.solutions[0].solutionDetails.push(newSolDetails);
    }

    if (this.userInfoService.userData.NumberFormatId === 1) {
      this.NumberFormat = 'sv-SE';
    } else if (this.userInfoService.userData.NumberFormatId === 2) {
      this.NumberFormat = 'en-US';
    }

    this.initiateList();
    this.initiateData();   
  }

  ngOnInitORI(): void {
    this.projectService.activePage = 3;
    this.contamination = this.projectService.projectdetails.contamination;
    this.contamination.applicationType = 'ASTM';
    this.solutions = this.projectService.projectdetails.solutions;

    let gasDetailLen = this.projectService.projectdetails.contamination.gasDetails.length;
    if (gasDetailLen > 0) {
      for (let i=0; i < gasDetailLen; i++) {
        let gasDet = this.projectService.projectdetails.contamination.gasDetails[i];
        switch (i) {
          case 0:
             this.contaminationType1 = gasDet.contaminationType;
             this.concentrationValue1 = gasDet.concentrationValue;
            break;
          case 1:
            this.contaminationType2 = gasDet.contaminationType;
            this.concentrationValue2 = gasDet.concentrationValue;
            break;
          case 2:
          this.contaminationType3 = gasDet.contaminationType;
          this.concentrationValue3 = gasDet.concentrationValue;
          break;
        }
      }
    }

    let solutionslLen = this.projectService.projectdetails.solutions.length;
    if (solutionslLen ===0) {
      this.addSolution();
    }else if (solutionslLen > 0) {
      for (let i=0; i < solutionslLen; i++) {
        let sol = this.projectService.projectdetails.solutions[i];
        if (sol.solutionDetails.length === 0) {
          this.addSolutionDetail(this.projectService.projectdetails.solutions[i]);
        }
        switch (i) {
          case 0 :
            this.mediaType1 = sol.solutionDetails[0].filterName;
            break;
          case 1 :
              this.mediaType2 = sol.solutionDetails[0].filterName;
              //(<HTMLInputElement>document.getElementById('txtMedia1')).value = sol.solutionDetails[0].filterName;
              break;
          case 2 :
            this.mediaType3 = sol.solutionDetails[0].filterName;
            //(<HTMLInputElement>document.getElementById('txtMedia2')).value = sol.solutionDetails[0].filterName;
            break;
        }
      }
    }

    if (this.projectService.projectdetails.solutions[0].solutionDetails.length===0) {
      let newSolDetails = this.projectService.getsolutionDetailsEmptyvalueStructure();
      this.projectService.projectdetails.solutions[0].solutionDetails.push(newSolDetails);
    }

    if (this.userInfoService.userData.NumberFormatId === 1) {
      this.NumberFormat = 'sv-SE';
    } else if (this.userInfoService.userData.NumberFormatId === 2) {
      this.NumberFormat = 'en-US';
    }

    this.initiateList();
    this.initiateData();
  }

  ngAfterViewInit() {    
    if (this.contaminationType1 !== undefined) {
      (<HTMLInputElement>document.getElementById('txtContamination0')).value = this.contaminationType1;
      let itemGas = {
        ChemID: this.contamination.gasDetails[0].chemicalID
      };
      //Modified by PP(2023-07-21) : Manual keyed in conc value missing after coming back from Results page. Why need to select contamination type when gas already been selected? this.selectContaminationType(itemGas,0, true);
    }
    if (this.contaminationType2 !== undefined) {
      (<HTMLInputElement>document.getElementById('txtContamination1')).value = this.contaminationType2;
      let itemGas = {
        ChemID: this.contamination.gasDetails[1].chemicalID
      };
      //Modified by PP(2023-07-21) : Manual keyed in conc value missing after coming back from Results page. Why need to select contamination type when gas already been selected? this.selectContaminationType(itemGas,1, true);
    }
    if (this.contaminationType3 !== undefined) {
      (<HTMLInputElement>document.getElementById('txtContamination2')).value = this.contaminationType3;
      let itemGas = {
        ChemID: this.contamination.gasDetails[2].chemicalID
      };
      //Modified by PP(2023-07-21) : Manual keyed in conc value missing after coming back from Results page. Why need to select contamination type when gas already been selected? this.selectContaminationType(itemGas,2, true);
    }
    //this.updateGasConcentration();
    if (this.mediaType1 !== undefined || this.mediaType1 !== "") {
      if ((<HTMLInputElement>document.getElementById('txtMedia0')) != null) {
        (<HTMLInputElement>document.getElementById('txtMedia0')).value = this.mediaType1;
      }
    }

    if (this.mediaType2 !== undefined || this.mediaType2 !== "") {
      if ((<HTMLInputElement>document.getElementById('txtMedia1')) != null) {
        (<HTMLInputElement>document.getElementById('txtMedia1')).value = this.mediaType2;
      }      
    }

    if (this.mediaType3 !== undefined || this.mediaType3 !== "") {
      if ((<HTMLInputElement>document.getElementById('txtMedia2')) != null) {
        (<HTMLInputElement>document.getElementById('txtMedia2')).value = this.mediaType3;
      }     
    }

    this.updateAirVolumeUnit();
    if (this.sharedService.convertLocaletoNumber(this.contamination.runningTime,this.NumberFormat) === 0) {
      this.calcRT(true);
    } else {
      this.calcRT(false);
    }
    this.calcTotAirVolume();
  }

  ngAfterContentInit() {
    var abc=123;
  }

  ngOnDestroy() {
    var abc=123;
  }

  updateGasConcentration() {
  if (this.contamination.gasDetails.length > 0) {
      for (let i=0; i<this.contamination.gasDetails.length; i++) {
        let itemGas = {
          ChemID: this.contamination.gasDetails[i].chemicalID
        };
        this.selectContaminationType(itemGas,i,false);
      }
    }
  }


  addContamination() {
    if (this.contamination.gasDetails.length > 2) {
    } else {
      this.inum = this.contamination.gasDetails.length ;
      var newGasDetails = this.projectService.getGasDetailsEmptyvalueStructure();
      newGasDetails.index = this.contamination.gasDetails.length;
      this.contamination.gasDetails.push(newGasDetails);
    }
  }

  addSolution() {
    if (this.solutions.length > 2) {
    }else{
      this.itotalsol = this.solutions.length +1;
      let newSolutions = this.projectService.getSolutionsForComparisonEmptyValueStructure();
      //let newSolDetails = this.projectService.getsolutionDetailsEmptyvalueStructure();
      let tempSolName = 'Solution '+ this.itotalsol;
      if (this.solutions.length > 1) {
        for (let i=0; i < this.solutions.length; i++) {
          if (tempSolName === this.solutions[i].solutionName) {
            let nxtIsol = this.itotalsol + 1;
            tempSolName = 'Solution ' + nxtIsol;
          }
        }
      }
      newSolutions.solutionID = this.itotalsol;
      newSolutions.solutionName = tempSolName;
      this.addSolutionDetail(newSolutions);
      this.solutions.push (newSolutions);
      this.datalistShow = "";
    }
  }

  addSolutionDetail(isolution:any) {
    let newCombinationGas = this.projectService.getCombinationGasEmptyvalueStructure();
    let newSolDetails = this.projectService.getsolutionDetailsEmptyvalueStructure();
    newSolDetails.combinationGas.push(newCombinationGas);
    isolution.solutionDetails.push(newSolDetails);
    this.addContamination();
  }

  initiateList() {
    this.AllDDLList = this.sharedService.listData;
    if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
      this.airflowList = this.AllDDLList.SI_List.AirFlow.List;
      this.temperatureList = this.AllDDLList.SI_List.Temperature.List;
      this.concUnitlist = this.AllDDLList.SI_List.ConcentrationUnits;
      this.airFlowUnitlist = this.AllDDLList.SI_List.AirFlowUnits;
    }else{
      this.airflowList = this.AllDDLList.US_List.AirFlow.List;
      this.temperatureList = this.AllDDLList.US_List.Temperature.List;
      this.concUnitlist = this.AllDDLList.US_List.ConcentrationUnits;
      this.airFlowUnitlist = this.AllDDLList.US_List.AirFlowUnits;
    }
    this.RHList = this.AllDDLList.Humidity.List;
    this.hoursperDayList = this.AllDDLList.HoursperDay.List;
    this.daysperWeekList = this.AllDDLList.DaysperWeek.List;
    this.weeksperYearList = this.AllDDLList.WeeksperYear.List;

    // astm contamination list
    this.contaminationList = this.AllDDLList.AstmChemicalMediaList;
    this.contaminationList1 = this.contaminationList;
    this.contaminationList2 = this.contaminationList;
    this.contaminationList3 = this.contaminationList;
  }

  initiateData() {
    if (this.userInfoService.userData != null || this.userInfoService.userData != undefined) {
      if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
        //Already been assigned from accountinto. this.contamination.airflowUnit = this.AllDDLList.UnitInfoClass.UnitInfo_SI.Airflow;
        this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
        this.selUnitFromProgSettings = 1;
        this.disableFlag=false;
      } else {
        //Already been assigned from accountinto. this.contamination.airflowUnit = this.AllDDLList.UnitInfoClass.UnitInfo_US.Airflow;
        this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
        this.selUnitFromProgSettings = 2;
        this.disableFlag=true;
      }
    } else {
      if (this.projectService.projectdetails.projectInfo != null || this.projectService.projectdetails.projectInfo != undefined) {
        if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
          this.contamination.airflowUnit = this.AllDDLList.UnitInfoClass.UnitInfo_SI.Airflow;
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
          this.selUnitFromProgSettings = 1;
          this.disableFlag=false;
        } else {
          this.contamination.airflowUnit = this.AllDDLList.UnitInfoClass.UnitInfo_US.Airflow;
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
          this.selUnitFromProgSettings = 2;
          this.disableFlag=true;
        }
      }
    }

    // if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
    //   this.contamination.airflowUnit = this.AllDDLList.UnitInfoClass.UnitInfo_SI.Airflow;
    //   this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
    // } else {
    //   this.contamination.airflowUnit = this.AllDDLList.UnitInfoClass.UnitInfo_US.Airflow;
    //   this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
    // }

    // if (this.projectService.projectdetails.projectInfo.id === 0) {
    //   if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
    //     this.selUnitFromProgSettings = 1;
    //   } else {
    //     this.selUnitFromProgSettings = 2;
    //   }
    // }

    this.contamination.airflow = this.sharedService.formatValue(this.projectService.projectdetails.contamination.airflow, true);

    if (this.contamination.airflowUnit !== "" && this.contamination.airflow !== undefined) {
      switch (this.contamination.airflowUnit) {
        case "m³/h":
          this.selAirFlowUnitFromProgSettings = "m³/h";
          break;
        case "CFM":
          this.selAirFlowUnitFromProgSettings = "CFM";
          break;
        case "m³/s":
          this.selAirFlowUnitFromProgSettings = "m³/s";
          break;
        case "L/s":
          this.selAirFlowUnitFromProgSettings = "L/s";
          break;
      }
    }

    switch (this.projectService.projectdetails.projectInfo.concUnit) {
      case "ppb":
        this.selectedConcUnit = "ppb";
        this.selConcUnitFromProgSettings = "ppb";
        break;
      case "mg/m³":
        this.selectedConcUnit = "mg/m³";
        this.selConcUnitFromProgSettings = "mg/m³";
        break;
    }
  }

  updateAirVolumeUnit() {
    if (this.userInfoService.userData != null || this.userInfoService.userData != undefined) {
      if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
        this.airVolumeUnit = this.airVolumeUnitm3h;
      } else {
        this.airVolumeUnit = this.airVolumeUnitft3;
      }
    } else {
      if (this.projectService.projectdetails.projectInfo != null || this.projectService.projectdetails.projectInfo != undefined) {
        if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
          this.airVolumeUnit = this.airVolumeUnitm3h;
        } else {
          this.airVolumeUnit = this.airVolumeUnitft3;
        }
      }
    }

    // if (this.projectService.projectdetails.projectInfo.unitId === 1) {
    //   this.airVolumeUnit = this.airVolumeUnitm3h;
    // } else if (this.projectService.projectdetails.projectInfo.unitId === 2) {
    //   this.airVolumeUnit = this.airVolumeUnitft3;
    // }
  }

  getElementName(whichElement:string, whichType:string) {
    let requiredElement: any;
    switch(whichElement) {
      case "Airflow":
        switch (whichType) {
          case "Input":
            requiredElement = this.txtAirflow.nativeElement;
          break;

          case "DataList":
            requiredElement=this.datalistAirflow.nativeElement;
          break;
        }
       break;
       case "Temperature":
        switch (whichType) {
          case "Input":
            requiredElement = this.txtTemperature.nativeElement;
          break;

          case "DataList":
            requiredElement=this.datalistTemperature.nativeElement;
          break;
        }
       break;
       case "RH":
        switch (whichType) {
          case "Input":
            requiredElement = this.txtRH.nativeElement;
          break;

          case "DataList":
            requiredElement=this.datalistRH.nativeElement;
          break;
        }
       break;
      case "Contamination0":
        switch (whichType) {
          case "Input":
            //requiredElement = this.txtContamination0.nativeElement;
            requiredElement = document.getElementById('txtContamination0');
          break;

          case "DataList":
            //requiredElement=this.datalistContamination0.nativeElement;
            requiredElement = document.getElementById('datalistContamination0');
          break;
        }
        break;
      case "Contamination1":
        switch (whichType) {
          case "Input":
            //requiredElement = this.txtContamination1.nativeElement;
            requiredElement = document.getElementById('txtContamination1');
            break;

          case "DataList":
            // requiredElement=this.datalistContamination1.nativeElement;
            requiredElement = document.getElementById('datalistContamination1');
          break;
        }
        break;
      case "Contamination2":
        switch (whichType) {
          case "Input":
            // requiredElement = this.txtContamination2.nativeElement;
            requiredElement = document.getElementById('txtContamination2');
          break;

          case "DataList":
            //requiredElement=this.datalistContamination2.nativeElement;
            requiredElement = document.getElementById('datalistContamination2');
          break;
        }
      break;
      case "Media1":
        switch (whichType) {
          case "Input":
            //requiredElement = this.txtMedia0.nativeElement;
            requiredElement = document.getElementById('txtMedia0');
          break;

          case "DataList":
            //requiredElement=this.datalistMedia0.nativeElement;
            requiredElement = document.getElementById('datalistMedia0');
          break;
        }
        break;
      case "Media2":
        switch (whichType) {
          case "Input":
            //requiredElement = this.txtMedia1.nativeElement;
            requiredElement = document.getElementById('txtMedia1');
            break;

          case "DataList":
            //requiredElement=this.datalistMedia1.nativeElement;
            requiredElement = document.getElementById('datalistMedia1');
          break;
        }
        break;
      case "Media3":
        switch (whichType) {
          case "Input":
            //  requiredElement = this.txtMedia2.nativeElement;
            requiredElement = document.getElementById('txtMedia2');
          break;

          case "DataList":
            //requiredElement=this.datalistMedia2.nativeElement;
            requiredElement = document.getElementById('datalistMedia2');
          break;
        }
      break;
    }
    return requiredElement;
  }

  onMouseClick(e: MouseEvent){
    if(this.datalistShow!=="") {
      let input:any;
      let datalist:any;
      let previousdatalist:any;
     // let datalistHeight,datalistWidth,datalistXPosition,datalistYPosition,WindowXPosition,WindowYPosition, dialogBoxXPosition, dialogBoxYPosition =0;
      // input = this.getElementName(this.datalistShow, "Input");
      // datalist = this.getElementName(this.datalistShow, "DataList");
      switch (this.datalistShow) {
        case "Contamination0":
          input = document.getElementById('txtContamination0');
          datalist = document.getElementById('datalistContamination0');
          break;
        case "Contamination1":
          input = document.getElementById('txtContamination1');
          datalist = document.getElementById('datalistContamination1');
          break;
        case "Contamination2":
          input = document.getElementById('txtContamination2');
          datalist = document.getElementById('datalistContamination2');
          break;
        case "Media0":
          input = document.getElementById('txtMedia0');
          datalist = document.getElementById('datalistMedia0');
          break;
        case "Media1":
          input = document.getElementById('txtMedia1');
          datalist = document.getElementById('datalistMedia1');
          //(<HTMLInputElement>document.getElementById('txtMedia1')).value = input.value;
          break;
        case "Media2":
          input = document.getElementById('txtMedia2');
          datalist = document.getElementById('datalistMedia2');
          //(<HTMLInputElement>document.getElementById('txtMedia2')).value = input.value;
          break;
        default:
          input = this.getElementName(this.datalistShow, "Input");
          datalist = this.getElementName(this.datalistShow, "DataList");
          break;
      }

      if (e.target== input) {
        if (this.sharedService.previousClickedDataList != "") {
          previousdatalist = this.getElementName(this.sharedService.previousClickedDataList, "DataList");
          previousdatalist.style.display = 'none';
          this.sharedService.previousClickedDataList = "";
        }
      }

      let clickOnDatalistArea=false;
      let targetElement = e.target;
      if (targetElement == input) {
        clickOnDatalistArea=true;
        this.sharedService.previousClickedDataList = this.datalistShow;
      } else {
        clickOnDatalistArea=false;
      }

      //Bug appear after clicking all 3 contaminants and click on Type dropdownlist, the datalist appear and hide away
      var tag = (<Element>e.target).innerHTML;
      if( tag.indexOf('Type') >= 0){
        clickOnDatalistArea = true;
      }

      console.log("clickOnDatalistArea =>  (" + clickOnDatalistArea + " )");
      if (clickOnDatalistArea===false){
        datalist.style.display = 'none';
        this.sharedService.previousClickedDataList = "";
      }
    }
  }

  onFocusEvent(ele:string, pIndex:number){
    let input:any;
    let datalist:any;
    let elementName=ele;
    let tmpTxtBox: any;
    let tmpDataList :any;

    switch (ele) {
      case 'Airflow':
        input = this.txtAirflow.nativeElement;
        datalist = this.datalistAirflow.nativeElement;
        break;
      case 'Temperature':
        input = this.txtTemperature.nativeElement;
        datalist = this.datalistTemperature.nativeElement;
        break;
      case 'RH':
        input = this.txtRH.nativeElement;
        datalist = this.datalistRH.nativeElement;
        break;
      case 'Contamination':
        tmpTxtBox = 'txtContamination' + pIndex.toString();
        tmpDataList = 'datalistContamination' + pIndex.toString();
        if (this.contaminationList === undefined || this.contaminationList === null || this.contaminationList.length === 0) {
          this.loading = true;
          if (this.sharedService.listData.AstmChemicalMediaList !== undefined) {
            this.contaminationList = this.AllDDLList.AstmChemicalMediaList;
            this.contaminationList1 = this.contaminationList;
            this.contaminationList2 = this.contaminationList;
            this.contaminationList3 = this.contaminationList;
            this.loading = false;
          }else{
            setTimeout(() => {
              this.contaminationList =this.AllDDLList.AstmChemicalMediaList;
              this.contaminationList1 = this.contaminationList;
              this.contaminationList2 = this.contaminationList;
              this.contaminationList3 = this.contaminationList;
              this.loading = false;
            },40000);
          }
        }
        input = document.getElementById(tmpTxtBox);
        datalist = document.getElementById(tmpDataList);
        elementName = ele + pIndex.toString();
        switch (pIndex) {
          case 0:
            this.contaminationList = this.contaminationList1;
            break;
          case 1:
            this.contaminationList = this.contaminationList2;
            break;
          case 2:
            this.contaminationList = this.contaminationList3;
            break;
        }
        break;
      // case 'Contamination1':
      //   if (this.contaminationList === undefined) {
      //     this.loading = true;
      //     if (this.sharedService.listData.AstmChemicalMediaList !== undefined) {
      //       this.contaminationList = this.AllDDLList.AstmChemicalMediaList;
      //       this.loading = false;
      //     }else{
      //       setTimeout(() => {
      //         this.contaminationList =this.AllDDLList.AstmChemicalMediaList;
      //         this.loading = false;
      //       },40000);
      //     }
      //   }
      //   input = document.getElementById('txtContamination0');
      //   datalist = document.getElementById('datalistContamination0');
      //   break;
      // case 'Contamination2':
      //   if (this.contaminationList === undefined) {
      //     this.loading = true;
      //     if (this.sharedService.listData.AstmChemicalMediaList !== undefined) {
      //       this.contaminationList = this.AllDDLList.AstmChemicalMediaList;
      //       this.loading = false;
      //     }else{
      //       setTimeout(() => {
      //         this.contaminationList =this.AllDDLList.AstmChemicalMediaList;
      //         this.loading = false;
      //       },40000);
      //     }
      //   }
      //   input = document.getElementById('txtContamination1');
      //   datalist = document.getElementById('datalistContamination1');
      //   break;
      // case 'Contamination3':
      //   if (this.contaminationList === undefined) {
      //     this.loading = true;
      //     if (this.sharedService.listData.AstmChemicalMediaList !== undefined) {
      //       this.contaminationList = this.AllDDLList.AstmChemicalMediaList;
      //       this.loading = false;
      //     }else{
      //       setTimeout(() => {
      //         this.contaminationList =this.AllDDLList.AstmChemicalMediaList;
      //         this.loading = false;
      //       },40000);
      //     }
      //   }
      //   input = document.getElementById('txtContamination2');
      //   datalist = document.getElementById('datalistContamination2');
      //   break;
      case 'Media':
        tmpTxtBox = 'txtMedia' + pIndex.toString();
        tmpDataList = 'datalistMedia' + pIndex.toString();
        input = document.getElementById(tmpTxtBox);
        datalist = document.getElementById(tmpDataList);
        elementName = ele + pIndex.toString();

        if (this.mediaList1 == undefined || this.mediaList2 == undefined || this.mediaList3 == undefined) {   
          let itemGas = {
            ChemID: this.contamination.gasDetails[pIndex].chemicalID
          };
          let ChemInfo = this.sharedService.getChemInfo(itemGas.ChemID); //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
          this.getMediaListfromSelectedContamination(itemGas.ChemID, ChemInfo, pIndex, false);
        } 
          
        switch (pIndex) {
          case 0:
            this.mediaList = this.mediaList1;
            break;
          case 1:
            this.mediaList = this.mediaList2;
            break;
          case 2:
            this.mediaList = this.mediaList3;
            break;
        }
        break;
      // case 'Media1':
      //   input = this.txtMedia0.nativeElement;
      //   datalist = this.datalistMedia0.nativeElement;
      //   break;
      // case 'Media2':
      //   input = this.txtMedia1.nativeElement;
      //   datalist = this.datalistMedia1.nativeElement;
      //   break;
      // case 'Media3':
      //   input = this.txtMedia2.nativeElement;
      //   datalist = this.datalistMedia2.nativeElement;
      //   break;
    }

    this.hideAllDataList(input.id);
    let me = this;
    this.datalistShow = elementName;
    if (datalist !== undefined && datalist !== null){
      datalist.style.display = 'block';
    }

    for (let option of datalist.options) {
      option.onclick = function () {
        input.value = this.value;
        switch(ele){
          case "Airflow":
            me.contamination.airflow = input.value;
            me.formatNumber('airflow',me.contamination.airflow, pIndex);
            me.calcTotAirVolume();
            break;
          case "Temperature":
            me.contamination.temperature = input.value;
            me.formatNumber('temperature',me.contamination.temperature, pIndex);
            break;
          case "RH":
            me.contamination.relativeHumidity = input.value;
            me.formatNumber('relativeHumidity',me.contamination.relativeHumidity, pIndex);
            break;
          // case "Contamination":
          //   switch (pIndex) {
          //     case 0:
          //       break;

          //   }
          //   break;
          // case "Contamination1":
          //   me.contaminationType1 = input.value;
          //   break;
          // case "Contamination2":
          //   me.contaminationType2 = input.value;
          //   break;
          // case "Contamination3":
          //   me.contaminationType3 = input.value;
          //   break;
          // case "Media1":
          //   me.media1 = input.value;
          //   break;
          // case "Media2":
          //   me.media2 = input.value;
          //   break;
          // case "Media3":
          //   me.media3 = input.value;
          //   break;
        }
        datalist.style.display = 'none';
        this.datalistShow="";
      }
    }
    datalist.style.width = input.offsetWidth + 'px';
    datalist.style.left = input.offsetLeft + 'px';
    datalist.style.top = input.offsetTop + input.offsetHeight + 'px';
  }

  // lostFocusEvent (strInputvalue:string, whichDataList:string, index:number) {
  //   let tmpTxtBox: any;
  //   switch (whichDataList){
  //     case "contaminationType":
  //       tmpTxtBox = 'txtContamination' + index.toString();
  //     break;
  //     case "mediaType":
  //       tmpTxtBox = 'txtMedia' + index.toString();
  //       break;
  //   }

  // }


  // hideAllDataList(exclude){
  //   let aryDatalist=[this.datalistAirflow, this.datalistTemperature, this.datalistRH];
  //   let aryDatalistName=['airflow', 'temperature', 'RH'];
  //   for (var x=0;x<aryDatalist.length;x++){
  //     let datalist = aryDatalist[x].nativeElement;
  //     let name=aryDatalistName[x];
  //     if (datalist.style.display==='block' && name!==exclude ){
  //       datalist.style.display = 'none';
  //     }
  //   }
  // }

  hideAllDataList(exclude){
    let datalist;
    let name;
    let blnGetElementbyID = false;
    blnGetElementbyID =  exclude.includes("txt");
    if (blnGetElementbyID) {
      let aryDatalist=['datalistContamination0','datalistContamination1','datalistContamination2','datalistMedia0','datalistMedia1','datalistMedia2'];
      let aryDatalistName=['txtContamination0','txtContamination1','txtContamination2','txtMedia0','txtMedia1','txtMedia2'];
      for (var i=0; i<aryDatalist.length; i++) {
        datalist = document.getElementById(aryDatalist[i]);
        name = aryDatalistName[i];
        if (datalist !== null && datalist.style.display==='block' && name!==exclude) {
          datalist.style.display = 'none';
        }
      }
    }else{
      let aryDatalist=[this.datalistAirflow, this.datalistTemperature, this.datalistRH];
      let aryDatalistName=['airflow', 'temperature', 'RH'];
      for (var x=0;x<aryDatalist.length;x++){
        datalist = aryDatalist[x].nativeElement;
        name = aryDatalistName[x];
        if (datalist.style.display==='block' && name!==exclude ){
          datalist.style.display = 'none';
        }
      }
    }

  }

  formatNumber(item, input, pIndex){
    let inputvalue=input;
    let output = this.sharedService.formatValue(input, true);

    switch(item) {
      case "Concentration":
        this.contamination.gasDetails[pIndex].concentrationValue = output;
        switch(pIndex) {
          case 0:
            this.concentrationValue1 = output;
            break;
          case 1:
            this.concentrationValue2 = output;
            break;
          case 2:
            this.concentrationValue3 = output;
            break;
        }

        break;
    }
  }

  calcRT (toUpdate:boolean) {
    let hours = this.hoursperdayval;
    let days = this.daysperweekval;
    let weeks = this.weeksperyearval;
    let totalhours = 0;
    if (hours > 0 && days >0 && weeks >0){
      totalhours = this.calculateService.CalculateRunningTime(hours,days,weeks);
    }
    if (totalhours > 0) {
      this.formatcalculatedTotalHours = this.sharedService.formatValue(totalhours, true);
      let showTotalHours = document.getElementById('divTotalRT');
      showTotalHours.innerHTML = "Running Time : " + this.formatcalculatedTotalHours + " hours"
      if (toUpdate===true) {
        this.contamination.runningTime = this.formatcalculatedTotalHours;           
      }
    }
  }

  calcTotAirVolume() {
    var RTValue = this.sharedService.convertLocaletoNumber(this.contamination.runningTime, this.NumberFormat);
    if (RTValue > 8784) {
      this.toastr.error('Running time cannot be more than 366 days', '');
      return;
    }

    let tothours = this.sharedService.convertLocaletoNumber(this.contamination.runningTime,this.NumberFormat);
    let totairflow = this.sharedService.convertLocaletoNumber(this.contamination.airflow,this.NumberFormat);
    let airflowUnit = this.contamination.airflowUnit ;
    let airflowm3h = totairflow;

    //Modified by PP(2023-11-10) : Bugs. Cannot only just convert from CFM - START
    // if (airflowUnit === "CFM") {
    //   airflowm3h =  this.calculateService.ConvertAirFlow(totairflow, 'CFM', 'm³/h');
    // }
    if (airflowUnit != 'm³/h') {
      airflowm3h =  this.calculateService.ConvertAirFlow(totairflow, airflowUnit, 'm³/h');
    }
    //Modified by PP(2023-11-10) : Bugs. Cannot only just convert from CFM - END

    let calcairvolumevalue = this.calculateService.CalculateTotalAirVolume(tothours,airflowm3h);
    let airvolumevalue = calcairvolumevalue ;

    //Modified by PP(2023-11-10) : Bugs. Cannot only just convert from CFM - START
    // if (airflowUnit === "CFM") {
    //   airvolumevalue =  this.calculateService.ConvertTotalAirVol_US(calcairvolumevalue);
    // }
    if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_US) {
      airvolumevalue =  this.calculateService.ConvertTotalAirVol_US(calcairvolumevalue);
    }
    //Modified by PP(2023-11-10) : Bugs. Cannot only just convert from CFM - END

    this.contamination.runningTime = this.sharedService.formatValue(tothours, true);
    this.contamination.airflow = this.sharedService.formatValue(totairflow, true);
    this.totAirVolume = this.sharedService.formatValue(airvolumevalue, false) + " " + this.airVolumeUnit;
    this.contamination.totalAirVolume = this.totAirVolume;
  }

  updateRuningTime() {
    this.contamination.runningTime = this.formatcalculatedTotalHours;
    this.calcTotAirVolume();
  }

//Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
/*getChemInfo(pChemID: number) {
  var chemInfo: any;
  for (var x=0;x<this.AllDDLList.ApplicationContaminationFromServer.AMCChemical.length;x++) {
    if (pChemID == this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID) {
      //Modified by JW(2022-10-04): Convert to US value for boiling point-start
      let selectedUnitId = this.projectService.projectdetails.projectInfo.unitId;
      let tbp  = this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Tbp;
      if (selectedUnitId === 2) {
        tbp = this.calculateService.ConvertTemperature(tbp,"US");
      }
      //Modified by JW(2022-10-04): Convert to US value for boiling point-end
      chemInfo = {
        contamination_type : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Substance,
        chemical_id : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID,
        chemicalFormula : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Formula,
        molecularWeight : this.sharedService.formatValue(this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Mw, false),
        casNo: this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].CasNo,
        boilingPoint: this.sharedService.formatValue(tbp, false),
        vapourPressure: this.sharedService.formatValue(this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Vp, false),
      }
      break;
    }
  }
  return chemInfo
}*/
//Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-END


  toggleUnit() {
    if(this.selUnitFromProgSettings === 2){
      this.selAirFlowUnitFromProgSettings = 'CFM';
      this.airFlowUnitlist = this.AllDDLList.US_List.AirFlowUnits;
      this.disableFlag = true;
    }
    else {
      this.airFlowUnitlist = this.AllDDLList.SI_List.AirFlowUnits;
      this.selAirFlowUnitFromProgSettings = 'm³/h';
      this.disableFlag = false;
    }
  }


  triggerDoneFromProgSettings() {
    var NeedToPostData = false; //Modified by PP(2023-02-28) : Save into user's table

    //Check Airflow Unit changed
    if (this.selAirFlowUnitFromProgSettings != this.contamination.airflowUnit) {
      NeedToPostData = true; //Modified by PP(2023-02-28) : Save into user's table 
      //Find Previous Unit
      var previousUnit = "";
      switch (this.contamination.airflowUnit) {
        case "m³/h":
          previousUnit = "m³/h";
          break;
        case "CFM":
          previousUnit = "CFM";
          break;
        case "m³/s":
          previousUnit = "m³/s";
          break;
        case "L/s":
          previousUnit = "L/s";
          break;
      }

      let convertedAirflow = this.calculateService.ConvertAirFlow(this.sharedService.convertLocaletoNumber(this.contamination.airflow, this.NumberFormat), previousUnit, this.selAirFlowUnitFromProgSettings);
      this.contamination.airflow = this.sharedService.formatValue(convertedAirflow, true);

      switch (this.selAirFlowUnitFromProgSettings) {
        case "m³/h":
          this.contamination.airflowUnit = "m³/h";
          break;
        case "CFM":
          this.contamination.airflowUnit = "CFM";
          break;
        case "m³/s":
          this.contamination.airflowUnit = "m³/s";
          break;
        case "L/s":
          this.contamination.airflowUnit = "L/s";
          break;
      }
    }

    //Check Concentration Unit changed
    if (this.selConcUnitFromProgSettings != this.selectedConcUnit) {
      NeedToPostData = true; //Modified by PP(2023-02-28) : Save into user's table 
      switch (this.selConcUnitFromProgSettings) {
        case "ppb":
          this.selectedConcUnit = "ppb";
          this.projectService.projectdetails.projectInfo.concUnit = "ppb";
          break;
        case "mg/m³":
          this.selectedConcUnit = "mg/m³";
          this.projectService.projectdetails.projectInfo.concUnit = "mg/m³";
          break;
      }
      //Trigger Concentration Calculation
      var ChemInfo:any;
      var item:any;
      for (var x=0;x<this.contamination.gasDetails.length;x++) {
        if (this.contamination.gasDetails[x].chemicalID > 0 && this.contamination.gasDetails[x].contaminationType != "") {
            ChemInfo = this.sharedService.getChemInfo(this.contamination.gasDetails[x].chemicalID); //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
            item = {
              ChemicalID: this.contamination.gasDetails[x].chemicalID,
              substance: this.contamination.gasDetails[x].contaminationType
          }
          this.startCalculateConcentration(this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[x].concentrationValue, this.NumberFormat), this.selectedConcUnit, ChemInfo, x);
        }
      }
    }

    //Check Metrics Unit changed
    var unitToChange = "";
    //if (this.selUnitFromProgSettings != this.projectService.projectdetails.projectInfo.unitId) {
    if (this.selUnitFromProgSettings != this.userInfoService.userData.UserUnitId) {
      NeedToPostData = true; //Modified by PP(2023-02-28) : Save into user's table
      switch (this.selUnitFromProgSettings) {
        case 1:
          unitToChange = "SI";
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
          this.projectService.projectdetails.projectInfo.unitId = 1;
          this.projectService.projectdetails.projectInfo.unitName = 'SI'; //Modified by JW(2022-10-04): update projectService.projectdetails.projectInfo.unitName when unit is changed in Program Settings
          break;

        case 2:
          unitToChange = "US";
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
          this.projectService.projectdetails.projectInfo.unitId = 2;
          this.projectService.projectdetails.projectInfo.unitName = 'US';  //Modified by JW(2022-10-04): update projectService.projectdetails.projectInfo.unitName when unit is changed in Program Settings
          break;
      }
      //this.updateAirVolumeUnit();
      //this.calcTotAirVolume();

      //Temperature
      var newTemperatureValue = this.calculateService.ConvertTemperature(this.sharedService.convertLocaletoNumber(this.contamination.temperature, this.NumberFormat), unitToChange);
      this.contamination.temperature = this.sharedService.formatValue(newTemperatureValue, true);

      //Boiling Point temperature
      for (var x=0;x<this.contamination.gasDetails.length;x++) {
        if (this.contamination.gasDetails[x].chemicalID > 0 && this.contamination.gasDetails[x].contaminationType != "") {
            ChemInfo = this.sharedService.getChemInfo(this.contamination.gasDetails[x].chemicalID); //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
            this.contamination.gasDetails[x].moreInformation.boilingPoint = ChemInfo.boilingPoint;
        }
      }
    }

    //Modified by PP(2023-02-28) : Save into user's table - START
    if (NeedToPostData) {
      var selConcUnitIDFromProgSettings = 0;
      var selConcUnitFromProgSettings = ""
      switch (this.selConcUnitFromProgSettings) {
        case "ppb":
          selConcUnitIDFromProgSettings = 1;
          selConcUnitFromProgSettings = "ppb";
        break;
        case "mg/m³":
          selConcUnitIDFromProgSettings = 2;
          selConcUnitFromProgSettings = "mg/m³";
        break;
      }

      var selUserUnitFromProgSettings = "";
      var selUserUnitIDFromProgSettings = 0
      switch (this.selUnitFromProgSettings) {
        case 1:
          selUserUnitFromProgSettings = "SI";
          selUserUnitIDFromProgSettings = 1;
          break;
        case 2:
          selUserUnitFromProgSettings = "US";
          selUserUnitIDFromProgSettings = 2;
          break;
      }

      var selAirflowUnitFromProgSettings = "";
      switch (this.selAirFlowUnitFromProgSettings) {
        case "m³/h":
          selAirflowUnitFromProgSettings = "m³/h";
          break;
        case "CFM":
          selAirflowUnitFromProgSettings = "CFM";
          break;
        case "m³/s":
          selAirflowUnitFromProgSettings = "m³/s";
          break;
        case "L/s":
          selAirflowUnitFromProgSettings = "L/s";
          break;
      }
      this.programSettingsService.postData(this.selUnitFromProgSettings,selConcUnitIDFromProgSettings, this.userInfoService.userData.NumberFormatId, this.selAirFlowUnitFromProgSettings).subscribe(res => {   
        this.userInfoService.userData.AirFlowUnit = selAirflowUnitFromProgSettings;
        this.userInfoService.userData.UserConcUnitId = selConcUnitIDFromProgSettings;
        this.userInfoService.userData.UserConcUnit = selConcUnitFromProgSettings;
        this.userInfoService.userData.UserUnitId = selUserUnitIDFromProgSettings;
        this.userInfoService.userData.UserUnitName = selUserUnitFromProgSettings;
        this.toastr.success('Data successfully inserted', '');

        //Need to reflect new units from accountinfo
        this.updateAirVolumeUnit();
        this.calcTotAirVolume();
      });
    }
    //Modified by PP(2023-02-28) : Save into user's table - END

  }


  startCalculateConcentration(pConcValue:any, pConcUnit:any, pChemInfo:any, pIndex:number) {
    var CalculatedConcValue:any;
    // If US unit
    var returnValueVPa = undefined;

    //Calculate Concentration Value
    CalculatedConcValue = this.calculateService.CalculateConcentration(pConcValue, pConcUnit, this.projectService.projectdetails.projectInfo.unitId, this.NumberFormat, this.contamination.temperature, this.sharedService.convertLocaletoNumber(pChemInfo.molecularWeight, this.NumberFormat));

    // switch(pIndex) {
    //   case 0:
    //     this.contaminationType1 = pChemInfo.contamination_type;
    //     break;

    //   case 1:
    //     this.contaminationType2 = pChemInfo.contamination_type;
    //     break;

    //   case 2:
    //     this.contaminationType3 = pChemInfo.contamination_type;
    //     break;
    // }
    this.solutions[pIndex].solutionDetails[0].combinationGas[0].chemicalID = pChemInfo.chemical_id;
    this.solutions[pIndex].solutionDetails[0].combinationGas[0].contaminationType = pChemInfo.contamination_type;
    this.solutions[pIndex].solutionDetails[0].combinationGas[0].concentrationValue = this.sharedService.formatValue(CalculatedConcValue, true); //Modified by PP(2023-08-03) : Concentration value is missing
    this.contamination.gasDetails[pIndex].chemicalID = pChemInfo.chemical_id;
    this.contamination.gasDetails[pIndex].contaminationType = pChemInfo.contamination_type;
    this.contamination.gasDetails[pIndex].concentrationValue = this.sharedService.formatValue(CalculatedConcValue, true);
    switch (pIndex) {
      case 0:
        this.concentrationValue1 = this.contamination.gasDetails[pIndex].concentrationValue;
        break;
      case 1:
        this.concentrationValue2 = this.contamination.gasDetails[pIndex].concentrationValue;
        break;
      case 2:
        this.concentrationValue3 = this.contamination.gasDetails[pIndex].concentrationValue;
        break;
    }
  }

  selectContaminationType (item:any, pIndex:number, needtoGetMediaList:boolean) {
    let ChemInfo = this.sharedService.getChemInfo(item.ChemID); //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
    this.contamination.gasDetails[pIndex].chemicalID = item.ChemID;
    this.contamination.gasDetails[pIndex].contaminationType = ChemInfo.contamination_type;
    this.contamination.gasDetails[pIndex].moreInformation.chemicalFormula = ChemInfo.chemicalFormula;
    this.contamination.gasDetails[pIndex].moreInformation.molecularWeight = ChemInfo.molecularWeight;
    this.contamination.gasDetails[pIndex].moreInformation.boilingPoint = ChemInfo.boilingPoint;
    this.contamination.gasDetails[pIndex].moreInformation.vapourPressureValue = ChemInfo.vapourPressureValue;
    this.contamination.gasDetails[pIndex].moreInformation.casNo = ChemInfo.cas_no;
    this.solutions[pIndex].solutionDetails[0].combinationID = 1;
    this.solutions[pIndex].solutionDetails[0].combinationGas[0].chemicalID = item.ChemID;
    this.solutions[pIndex].solutionDetails[0].combinationGas[0].contaminationType = ChemInfo.contamination_type;
    this.solutions[pIndex].solutionDetails[0].combinationGas[0].index = pIndex;

    if (needtoGetMediaList === true) {
      this.getMediaListfromSelectedContamination(item.ChemID,ChemInfo,pIndex,true);
    }

    // if (item.ChemID > 0) {
    //   let astmChemMediaListfrmSvr = this.AllDDLList.AstmChemicalMediaList;
    //   this.mediaList = [];
    //   if (astmChemMediaListfrmSvr.length > 0) {
    //     for (let x=0; x < astmChemMediaListfrmSvr.length; x++) {
    //       if (astmChemMediaListfrmSvr[x].ChemID === item.ChemID) {
    //         this.mediaList = astmChemMediaListfrmSvr[x].Media;
    //         break;
    //       }
    //     }
    //     switch(pIndex) {
    //       case 0:
    //         (<HTMLInputElement>document.getElementById('txtMedia0')).value = "";
    //         this.mediaList1 = [];
    //         this.mediaList1 = this.mediaList;
    //         break;
    //       case 1:
    //         (<HTMLInputElement>document.getElementById('txtMedia1')).value = "";
    //         this.mediaList2 = [];
    //         this.mediaList2 = this.mediaList;
    //         break;
    //       case 2:
    //         (<HTMLInputElement>document.getElementById('txtMedia2')).value = "";
    //         this.mediaList3 = [];
    //         this.mediaList3 = this.mediaList;
    //         break;
    //     }
    //   }
    //   switch (this.selectedConcUnit) {
    //     case "ppb":
    //       this.startCalculateConcentration(1, "ppb", ChemInfo, pIndex);
    //       break;

    //     case "mg/m³":
    //       this.startCalculateConcentration(1, "ppb", ChemInfo, pIndex);
    //       this.startCalculateConcentration(this.contamination.gasDetails[pIndex].concentrationValue, "mg/m³", ChemInfo, pIndex);
    //   }
    // }
    switch (this.selectedConcUnit) {
      case "ppb":
        this.startCalculateConcentration(1, "ppb", ChemInfo, pIndex);
        break;

      case "mg/m³":
        this.startCalculateConcentration(1, "ppb", ChemInfo, pIndex);
        this.startCalculateConcentration(this.contamination.gasDetails[pIndex].concentrationValue, "mg/m³", ChemInfo, pIndex);
    }
  }

  getMediaListfromSelectedContamination(gasId:number, pChemInfo:any, pIndex, pUpdateExistingMediaNameToNull:boolean) {
    if (gasId > 0) {
      let astmChemMediaListfrmSvr = this.AllDDLList.AstmChemicalMediaList;
      this.mediaList = [];
      if (astmChemMediaListfrmSvr != undefined) {
        if (astmChemMediaListfrmSvr.length > 0) {
          for (let x=0; x < astmChemMediaListfrmSvr.length; x++) {
            if (astmChemMediaListfrmSvr[x].ChemID === gasId) {
              this.mediaList = astmChemMediaListfrmSvr[x].Media;
              break;
            }
          }
          switch(pIndex) {
            case 0:
              if (pUpdateExistingMediaNameToNull) {
                (<HTMLInputElement>document.getElementById('txtMedia0')).value = "";
              }             
              this.mediaList1 = [];
              this.mediaList1 = this.mediaList;
              break;
            case 1:
              if (pUpdateExistingMediaNameToNull) {
                (<HTMLInputElement>document.getElementById('txtMedia1')).value = "";
              }            
              this.mediaList2 = [];
              this.mediaList2 = this.mediaList;
              break;
            case 2:
              if (pUpdateExistingMediaNameToNull) {
                (<HTMLInputElement>document.getElementById('txtMedia2')).value = "";
              }            
              this.mediaList3 = [];
              this.mediaList3 = this.mediaList;
              break;
          }
        }
      }
     
      // switch (this.selectedConcUnit) {
      //   case "ppb":
      //     this.startCalculateConcentration(1, "ppb", pChemInfo, pIndex);
      //     break;

      //   case "mg/m³":
      //     this.startCalculateConcentration(1, "ppb", pChemInfo, pIndex);
      //     this.startCalculateConcentration(this.contamination.gasDetails[pIndex].concentrationValue, "mg/m³", pChemInfo, pIndex);
      // }
    }
  }


  selectMedia (selectedmedia: any, pIndex:number) {
    switch(pIndex) {
      case 0:
        //this.mediaType1 = selectedmedia.MediaName;
        (<HTMLInputElement>document.getElementById('txtMedia0')).value = selectedmedia.MediaName;
        break;
      case 1:
        //this.mediaType2 = selectedmedia.MediaName;
        (<HTMLInputElement>document.getElementById('txtMedia1')).value = selectedmedia.MediaName;
        break;
      case 2:
        //this.mediaType3 = selectedmedia.MediaName;
        (<HTMLInputElement>document.getElementById('txtMedia2')).value = selectedmedia.MediaName;
        break;
    }
    this.solutions[pIndex].solutionDetails[0].molecularID = selectedmedia.Id;
    this.solutions[pIndex].solutionDetails[0].filterName = selectedmedia.MediaName;
    this.solutions[pIndex].solutionDetails[0].filterDBName = selectedmedia.MediaDBName;
    this.solutions[pIndex].solutionDetails[0].astmWeight = selectedmedia.ASTMWeight;
    this.solutions[pIndex].solutionDetails[0].astmvolume = selectedmedia.ASTMVolume;
  }

  removeSolution(pIndex) {
    this.contaminationType1 = "";
    this.contaminationType2 = "";
    this.contaminationType3 = "";

    this.mediaType1 = "";
    this.mediaType2 = "";
    this.mediaType3 = "";

    this.concentrationValue1 = "";
    this.concentrationValue2 = "";
    this.concentrationValue3 = "";

    this.solutions.splice(pIndex, 1);
    this.contamination.gasDetails.splice(pIndex,1);

    // //Reindex
    for (var x=0;x<this.solutions.length;x++) {
      this.solutions[x].solutionID = x+1;
      switch(x) {
        case 0:
          this.contaminationType1 = this.solutions[x].solutionDetails[0].combinationGas[0].contaminationType;
          this.mediaType1 = this.solutions[x].solutionDetails[0].filterName;
          this.concentrationValue1 = this.contamination.gasDetails[x].concentrationValue;
          break;
        case 1:
          this.contaminationType2 = this.solutions[x].solutionDetails[0].combinationGas[0].contaminationType;
          this.mediaType2 = this.solutions[x].solutionDetails[0].filterName;
          this.concentrationValue2 = this.contamination.gasDetails[x].concentrationValue;
          break;
        case 2:
          this.contaminationType3 = this.solutions[x].solutionDetails[0].combinationGas[0].contaminationType;
          this.mediaType3 = this.solutions[x].solutionDetails[0].filterName;
          this.concentrationValue3 = this.contamination.gasDetails[x].concentrationValue;
          break;
      }
    }

  }

  detectKeyChanges(WhichItem, pIndex) {
    switch(WhichItem) {
      case "Concentration":
        switch(pIndex) {
          case 0:
            this.formatNumber(WhichItem,this.concentrationValue1, pIndex);
            break;
          case 1:
            this.formatNumber(WhichItem,this.concentrationValue2, pIndex);
            break;
          case 2:
            this.formatNumber(WhichItem,this.concentrationValue3, pIndex);
            break;
        }

        //Modified by PP(2023-07-28) : Calculate Alternate Concentration Value - START
        var currentConcValue = this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[pIndex].concentrationValue, this.NumberFormat);
        var molecularWt = this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[pIndex].moreInformation.molecularWeight, this.NumberFormat);
        this.updateAltConcValue(pIndex, currentConcValue, molecularWt);
        //Modified by PP(2023-07-28) : Calculate Alternate Concentration Value - END

        this.updateNewConcentrationToSolutions(pIndex, this.contamination.gasDetails[pIndex].concentrationValue);
        break;
    }
  }

  setPoppers() {
    let AddSolutionInfoBtn = document.querySelector('#AddSolutionInfoBtn');
    let AddSolutionInfo = document.getElementById('divAddSolutionInfo');

    this.createPop(AddSolutionInfoBtn, AddSolutionInfo);
  }

  showHideInfoToggle(event) {
    let AddSolutionInfo = document.getElementById('divAddSolutionInfo');

    if (!this.AddSolutionInfo && event === 'AddSolutionInfo') {
      AddSolutionInfo.setAttribute('data-show', '');
      this.AddSolutionInfo = true;
    } else if (this.AddSolutionInfo && event === 'AddSolutionInfo') {
      AddSolutionInfo.removeAttribute('data-show');
      this.AddSolutionInfo = false;
    }
  }

  createPop(ref:any, popper:any ) {
    createPopper(ref, popper, {
      placement: 'top-start',
      modifiers: [
         {
           name: "offset",
           options: {
             offset: [0, 8],
           },
         },
      ],
    });
  }

  toggleEditMode(i:number){
    let currentEditMode = this.arrSolEditMode[i];
    if (currentEditMode === false) {
      this.arrSolEditMode[i] = true;
      switch (i) {
        case 0:
          this.solName1 = this.solutions[i].solutionName;
        break;
        case 1:
          this.solName2 = this.solutions[i].solutionName;
        break;
        case 2:
          this.solName3 = this.solutions[i].solutionName;
        break;
      }
    }else {
      this.arrSolEditMode[i] = false;
      switch(i) {
        case 0:
          this.solName1 = (<HTMLInputElement>document.getElementById('txtSolName1')).value ;
          if (this.solName1 === '') {
            this.solName1 = 'Solution 1';
            (<HTMLInputElement>document.getElementById('txtSolName1')).value = this.solName1;
          }
            this.solutions[i].solutionName = this.solName1;
          break;
        case 1:
          this.solName2 = (<HTMLInputElement>document.getElementById('txtSolName2')).value ;
          if (this.solName2 === '') {
            this.solName2 = 'Solution 2';
            (<HTMLInputElement>document.getElementById('txtSolName2')).value = this.solName2;
          }
            this.solutions[i].solutionName = this.solName2;
          break;
        case 2:
          this.solName3 = (<HTMLInputElement>document.getElementById('txtSolName3')).value ;
          if (this.solName3 === '') {
            this.solName3 = 'Solution 3';
            (<HTMLInputElement>document.getElementById('txtSolName3')).value = this.solName3;
          }
            this.solutions[i].solutionName = this.solName3;
          break;
      }
    }
  }

  //Modified by JW(2022-10-05): filter dropdown list based on input entries-start
  searchGas(pIndex:number) {
    let tmpTxtBox = 'txtContamination' + pIndex.toString();
    let inptxt = (<HTMLInputElement>document.getElementById(tmpTxtBox)).value;
    inptxt = inptxt.toLowerCase();
    let tmpList: any = [];
    if (inptxt !== "") {
      if (this.AllDDLList.AstmChemicalMediaList.length > 0){
        for (let i=0; i<this.AllDDLList.AstmChemicalMediaList.length; i++) {
          let tmpname = this.AllDDLList.AstmChemicalMediaList[i].ChemName;
          tmpname = tmpname.toLowerCase();
          if (tmpname.includes(inptxt)){
            tmpList.push(this.AllDDLList.AstmChemicalMediaList[i]);
          }
        }
      }
    }else{
      tmpList = this.AllDDLList.AstmChemicalMediaList ;
    }
    if (tmpList!==undefined) {
      switch (pIndex){
        case 0:
          this.contaminationList1 = tmpList;
          this.contaminationList = this.contaminationList1;
          break;
        case 1:
          this.contaminationList2 = tmpList;
          this.contaminationList = this.contaminationList2;
          break;
        case 2:
          this.contaminationList3 = tmpList;
          this.contaminationList = this.contaminationList3;
          break;
      }
    }

    this.onFocusEvent("Contamination", pIndex);
  }

  searchMedia(pIndex:number) {
    let tmpTxtBox = 'txtMedia' + pIndex.toString();
    let inptxt = (<HTMLInputElement>document.getElementById(tmpTxtBox)).value;
    inptxt = inptxt.toLowerCase();
    let tmpList: any = [];
    if (inptxt !== "") {
      if (this.mediaList.length > 0){
        for (let i=0; i<this.mediaList.length; i++) {
          let tmpname = this.mediaList[i].MediaName;
          tmpname = tmpname.toLowerCase();
          if (tmpname.includes(inptxt)){
            tmpList.push(this.mediaList[i]);
          }
        }
        if (tmpList!==undefined) {
          switch (pIndex){
            case 0:
              this.mediaList1 = tmpList;
              this.mediaList = this.mediaList1;
              break;
            case 1:
              this.mediaList2 = tmpList;
              this.mediaList = this.mediaList2;
              break;
            case 2:
              this.mediaList3 = tmpList;
              this.mediaList = this.mediaList3;
              break;
          }
        }
      }
    }else {
      switch (pIndex){
        case 0:
          tmpList = this.mediaList1;
          this.mediaList = this.mediaList1;
          break;
        case 1:
          tmpList = this.mediaList2;
          this.mediaList = this.mediaList2;
          break;
        case 2:
          tmpList = this.mediaList3;
          this.mediaList = this.mediaList3;
          break;
      }
    }
    this.onFocusEvent("Media", pIndex);
  }
  //Modified by JW(2022-10-05): filter dropdown list based on input entries-end

  next(){
    this.nextStep.emit();
  }

  getMediaName() { 
    var abc=123;
    // if (backendStructure.Params.CalcType === 'ASTM') {
    //   if (soldet.filterName == '' && soldet.filterDBName == '') {

    //   }
    // }
  }

  triggerASTMCancelFromProgSettings() {
    //Unit
    if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
      this.selUnitFromProgSettings = 1;
      this.disableFlag=false;
    } else {
      this.selUnitFromProgSettings = 2;
      this.disableFlag=true;
    }

    //Concentration Unit
    switch (this.userInfoService.userData.UserConcUnit) {
      case "ppb":
        this.selectedConcUnit = "ppb";
        this.selConcUnitFromProgSettings = "ppb";
        break;
      case "mg/m³":
        this.selectedConcUnit = "mg/m³";
        this.selConcUnitFromProgSettings = "mg/m³";
        break;
    }

    //Airflow Unit
    switch (this.contamination.airflowUnit) {
      case "m³/h":
        this.selAirFlowUnitFromProgSettings = "m³/h";
        break;
      case "CFM":
        this.selAirFlowUnitFromProgSettings = "CFM";
        break;
      case "m³/s":
        this.selAirFlowUnitFromProgSettings = "m³/s";
        break;
      case "L/s":
        this.selAirFlowUnitFromProgSettings = "L/s";
        break;
    } 
  }

    //Modified by PP(2023-07-28) : Calculate Alternate Concentration Value - START
    updateAltConcValue(pIndex, pConcValue, pMolWt) {
      var altConcUnit = "";
      switch (this.projectService.projectdetails.projectInfo.concUnit) {
        case "ppb":
          altConcUnit = "mg/m³";
          this.contamination.gasDetails[pIndex].altConcUnit = "mg/m³";
          break;
        case "mg/m³":
          altConcUnit = "ppb";
          this.contamination.gasDetails[pIndex].altConcUnit = "ppb";
          break;
      }
      var CalculatedConcValue = this.calculateService.CalculateConcentration(pConcValue, altConcUnit, this.projectService.projectdetails.projectInfo.unitId, this.NumberFormat, this.contamination.temperature, pMolWt);
      this.contamination.gasDetails[pIndex].altConcValue = this.sharedService.formatValue(CalculatedConcValue, true);
    }
  
    updateNewConcentrationToSolutions(pIndex, newConcValue) {
      for (let i=0 ; i< this.solutions.length; i++) {
        for (let j=0 ; j< this.solutions[i].solutionDetails.length; j++) {
          for (let k=0 ; k< this.solutions[i].solutionDetails[j].combinationGas.length; k++) {
            if (this.solutions[i].solutionDetails[j].combinationGas[k].index === pIndex) {
              this.solutions[i].solutionDetails[j].combinationGas[k].concentrationValue = this.sharedService.convertLocaletoNumber(newConcValue, this.NumberFormat);
            }
          }
        }
      }
    }
    //Modified by PP(2023-07-28) : Calculate Alternate Concentration Value - END

}
